import { render } from "./ProjectPublicationHistoryListCollapse.vue?vue&type=template&id=7280d5d0&scoped=true"
import script from "./ProjectPublicationHistoryListCollapse.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListCollapse.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListCollapse.vue?vue&type=style&index=0&id=7280d5d0&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7280d5d0"]])

export default __exports__